import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  container: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: theme.new.spacing.medium,
  },
  text: {
    ...theme.typography.body_regular,
    color: theme.new.color.textSecondary,
  },
}));

export default useStyles;
